import React from 'react'
import { Product, ProductTypes } from 'models/Product'
import { Text } from 'components/Text'
import { capitalize } from 'utils/capitalize'
import { ProductCard } from '../ProductCard'
import { ProductTypeSectionRoot, Cards } from './ProductTypeSection.styles'
import { useAddToCart } from 'features/ECommerce/hooks/useAddToCart'

type ProductTypeSectionProps = {
  type: ProductTypes
  products?: Product[]
}

export const ProductTypeSection = ({ type, products }: ProductTypeSectionProps) => {
  const addToCart = useAddToCart()

  if (!products || products.length < 1) return null

  return (
    <ProductTypeSectionRoot>
      <Text
        size="h4"
        as="h4"
        weight="bold"
        color="primary-800"
        align={{ '@initial': 'center', '@bp2': 'left' }}
        css={{ width: '100%' }}
      >
        {capitalize(type)}
      </Text>
      <Cards>
        {products.map((product) => (
          <ProductCard key={product.productId} product={product} onAdd={addToCart} />
        ))}
      </Cards>
    </ProductTypeSectionRoot>
  )
}

ProductTypeSection.displayName = 'ProductTypeSection'
